export function mixSelectableChild(key, valuePropName = 'value', parentValuePropName = 'value') {
  return {
    inject: {
      [key]: {
        default: null
      }
    },
    props: {
      [valuePropName]: {
        type: [String, Number],
        default: ''
      }
    },
    computed: {
      isSelected() {
        if (!this[key]) {
          return false
        }
        return this[valuePropName] == this[key][parentValuePropName]
      }
    },
    methods: {
      triggerSelect() {
        if (this[key]) {
          this[key].triggerChange(this[valuePropName])
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./packages/utils/mix-selectable-child.js